// extracted by mini-css-extract-plugin
export var icon = "_7w-1";
export var subtext = "_7w-0";